export default __webpack_public_path__ + "static/media/logo.c886f3c4.png";